import { FieldError as RHFFieldError } from 'react-hook-form';

export const resolveErrorMessage = (
  error: RHFFieldError | undefined,
  translate: (code: string) => string,
): string | undefined => {
  if (error?.message) {
    return translate(error.message);
  }
};
